export default [
  {
    title: 'Destek Hattı',
    icon: 'fad fa-user-headset',
    route: 'destek-hatti-listele',
    children: [],
  },
];
